import { VerifyResetCodeError } from '@/models/models'

export const VERIFY_RESET_CODE_ERROR_KEYS: Readonly<
  Record<number, string>
> = Object.freeze({
  [VerifyResetCodeError._1]: 'forgotPassword.verifyCode.errors.codeNotValid',
  [VerifyResetCodeError._2]: 'forgotPassword.verifyCode.errors.userDisabled',
  [VerifyResetCodeError._3]:
    'forgotPassword.verifyCode.errors.multipleAccountsFound',
  [VerifyResetCodeError._4]: 'forgotPassword.verifyCode.errors.tooManyAttempts'
})

export const LOGIN_ERROR_CODE_KEYS: Readonly<Record<number, string>> =
  Object.freeze({
    1: 'login.errors.invalidCredentials',
    2: 'login.errors.lockedOut',
    5: 'login.errors.userDisabled'
  })

export const LOGIN_ERROR_MESSAGE_KEYS: Readonly<Record<string, string>> =
  Object.freeze({
    'Incorrect username or password.': 'login.errors.invalidCredentials',
    'Too many incorrect attempts. Please try again later.':
      'login.errors.tooManyIncorrectAttempts',
    'Too many login attempts. Please try again later.':
      'login.errors.tooManyLoginAttempts'
  })